var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22h18V7",
    stroke: "#2B2634",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5 3 22l5 5.5",
    stroke: "#2B2634",
    strokeWidth: 2,
    strokeLinecap: "square",
    fill: "transparent"
  })));
};
export { SvgArrowUpRight as ReactComponent };
export default __webpack_public_path__ + "eda17ef843286c3a39877da89b780ba7.svg";